/* eslint-disable vars-on-top */
import { debug } from 'cc';
import Game from './Game';
import { IActivityEventDataType, ActivityEventName } from './Config/ActivityConfigType';

declare global {
    /**
     * 全域用戶行為佇列
     */
    /* eslint-disable no-var */
    var activity: any[];
}

export default class ActivityManager<TActivityEventDataType extends IActivityEventDataType = IActivityEventDataType> {
    private _hasConfig: boolean = false;
    private _initPromise: Promise<void> = null;
    private _initPromiseResolve: () => void = null;

    constructor() {
        this._initPromise = new Promise<void>((resolve) => {
            this._initPromiseResolve = resolve;
        });
        window.activity = window.activity || [];
    }

    public get initPromise() {
        return this._initPromise;
    }

    public async send<T extends keyof TActivityEventDataType>(eventName: T | string, data: TActivityEventDataType[T]) {
        debug('ActivityManager.send', eventName, data);
        if (Game.config.isFakeToken) {
            return;
        }
        // 無論如何, Config 都要是第一個設定的
        if (!this._hasConfig) {
            if (eventName !== ActivityEventName.Config) {
                await this._initPromise;
            } else {
                this._hasConfig = true;
                window.activity.push([eventName, data]);
                this._initPromiseResolve();
                return;
            }
        }
        window.activity.push([eventName, data]);
    }
}
